import axios from "@/plugins/axios";
import moment from "moment";

export default {
    
    list(filters) {

        let params = {
            start_date: filters.start_date,
            order: "creditor_id",
            limit: 9999
        };

        if (filters.creditorIds) {
            params.creditors_id = filters.creditorIds;
        };

        if (filters.approachesTypes){
            params.approachesTypes = filters.approachesTypes;
        };

        if (filters.skipTypes){
            params.skipsTypes = filters.skipTypes;
        };
        
        return axios.httpApi.get("/prepare-history", {params});
    },

    disable(stimulusId){
        let url = `/prepare-history/${stimulusId}/disable`;
        return axios.httpApi.post(url);
    }
}